import { createBrowserRouter } from "react-router-dom";
import { Home } from "./pages/home";
import { Login } from "./pages/login";
import { PasswordReset } from "./pages/password-reset";
import { NewReg } from "./pages/new-registration";
import { Register } from "./pages/register";
import { RegisterReffered } from "./pages/register-reffered";
import { OTP } from "./pages/otp";
import { RegisterSuccess } from "./pages/register-sucess";
import PersistLogin from "./common/components/persistence/PersistLogin";
import { RequireAuth } from "./common/components/requireAuth";
import { Dashboard } from "./pages/dashboard/layout";
import { NotFound } from "./pages/404";
import { Layout } from "./layout";
import { Stats } from "./pages/dashboard/stats";
import { Products } from "./pages/dashboard/products";
import { ProductDetailsPage } from "./pages/dashboard/players/product-details";
import { AddInventory } from "./pages/dashboard/add-inventory";
import { ProductInventoryView } from "./pages/dashboard/product-inventory-view";
import { Orders } from "./pages/dashboard/orders";
import { MyDistributors } from "./pages/dashboard/my-distributors";
import { Discounts } from "./pages/dashboard/discounts";
import { MakeOrder } from "./pages/dashboard/make-order";
import { Settings } from "./pages/dashboard/settings";
import { Invoices } from "./pages/dashboard/invoices";
import { Invoice } from "./pages/dashboard/invoices/subs/view";
import { Delivery } from "./pages/dashboard/delivery";
import { NewDelivery } from "./pages/dashboard/delivery/new-delivery";
import { Requests } from "./pages/dashboard/requests";
import { Companies } from "./pages/dashboard/admin/companies";
import { ComapanyDetails } from "./pages/dashboard/admin/company-details";
import { Rfq } from "./pages/dashboard/rfq";
import { ViewRFQ } from "./pages/dashboard/rfq/view-rfq";
import { RespondRfq } from "./pages/dashboard/rfq/respond-rfq";
import { NewRFQ } from "./pages/dashboard/rfq/new-rfq";
import { EditRfq } from "./pages/dashboard/edit-rfq";
import { AdminProducts } from "./pages/dashboard/admin/products";
import { AdminProductDetails } from "./pages/dashboard/admin/product-details";
import { InviteCompanies } from "./pages/dashboard/nafdac/invite-companies";
import OurTeam from "./pages/our-team";
import Portfolio from "./pages/portfolio";
import AdminDashboard from "./pages/dashboard/admin/dashboard";
import DRF from "./pages/dashboard/admin/drf";
import AdminCluster from "./pages/dashboard/admin/cluster";
import { RegisterInvited } from "./pages/register-invited";
import { StateMinistryStats } from "./pages/dashboard/stats/subs/stateMinistryStat";
import { MinistryAdminStats } from "./pages/dashboard/stats/subs/ministryAdminStats";
import HospitalHeadFinancial from "./pages/dashboard/hospital-head/drf/financial/financial";
import HospitalHeadReport from "./pages/dashboard/hospital-head/drf/report/report";
import PharmacyHeadStat from "./pages/dashboard/pharmacy-head/stat";
import PharmacyHeadFinancialManagement from "./pages/dashboard/pharmacy-head/financial-management";
import DRFTransactions from "./pages/dashboard/admin/transactions.tsx";
import DGHealthDashboard from "./pages/dashboard/dg-health/financials";
import DRFUser from "./pages/dashboard/drf/user-management";
// import Retailer from "./pages/dashboard/drf";
import StateDashboard from "./pages/dashboard/state-secretariat";
import FundAllocationHistory from "./pages/dashboard/state-secretariat/fund-history";
import SecreataryFinancials from "./pages/dashboard/state-secretariat/financial-management";
import DRFFacility from "./pages/dashboard/state-secretariat/financial-management/DRFFacility";
import AccountantFinancials from "./pages/dashboard/accountant/financial";
import AccountantAudit from "./pages/dashboard/accountant/audit";
import PharmacyHeadInventory from "./pages/dashboard/pharmacy-head/inventory";
import AllPharmacyDrugs from "./pages/dashboard/pharmacy-head/inventory/all-drugs";
import PharmacyHeadNotifications from "./pages/dashboard/pharmacy-head/inventory/notifications";
import ReportMonitoring from "./pages/dashboard/reporting-monitoring";
import MonthSale from "./pages/dashboard/accountant/financial/monthSale";
import Wallet from "./pages/dashboard/wallet";
import AdminWallet from "./pages/dashboard/admin/wallet";
import Recall from "./pages/dashboard/recall";
import ViewRecall from "./pages/dashboard/recall/view-recall/view-recall";
import { MessagingPage } from "./pages/messaging";
import { DashboardMessages } from "./pages/dashboard/messages";
import { NotificationCenter } from "./common/components/NotificationCenter";
import ScanToRecieve from "./pages/dashboard/delivery/scan-delivery/scan-recieve";
import ScanRecall from "./pages/dashboard/recall/scan-recall/scan-recall";
import AutoDelivery from "./pages/dashboard/delivery/auto-delivery";
import Address from "./pages/dashboard/address";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "reset-password", element: <PasswordReset /> },
      { path: "register", element: <NewReg /> },
      { path: "old-registrationadf", element: <Register /> },
      { path: "register/referred", element: <RegisterReffered /> },
      { path: "register/invited", element: <RegisterInvited /> },
      { path: "otp", element: <OTP /> },
      { path: "register/success", element: <RegisterSuccess /> },
      { path: "our-team", element: <OurTeam /> },
      { path: "portfolio", element: <Portfolio /> },
      { path: "messages", element: <MessagingPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },

  {
    element: <PersistLogin />,
    children: [
      {
        element: <RequireAuth />,
        children: [
          {
            path: "/dashboard/",
            element: <Dashboard />,

            children: [
              { path: "stats", element: <Stats /> },
              { path: "products", element: <Products /> },
              { path: "products/:id", element: <ProductDetailsPage /> },
              { path: "inventories", element: <AddInventory /> },
              {
                path: "inventories/:productId",
                element: <ProductInventoryView />,
              },
              { path: "requisition", element: <Orders /> },
              { path: "my-team/:companyType", element: <MyDistributors /> },
              { path: "requisition/make-requisition", element: <MakeOrder /> },
              { path: "settings", element: <Settings /> },
              { path: "invoices", element: <Invoices /> },
              { path: "invoices/:quotationId", element: <Invoice /> },
              { path: "logistic/invoice", element: <Invoices /> },
              { path: "logistic/invoice/:quotationId", element: <Invoice /> },
              { path: "refund/invoice", element: <Invoices /> },
              { path: "wallet", element: <Wallet /> },
              { path: "deliveries", element: <Delivery /> },
              { path: "address", element: <Address /> },
              {
                path: "deliveries/scan-receive/:id",
                element: <ScanToRecieve />,
              },
              { path: "discounts", element: <Discounts /> },
              { path: "recall", element: <Recall /> },
              { path: "recall/:id", element: <ViewRecall /> },
              { path: "recall/scan/:id", element: <ScanRecall /> },
              {
                path: "deliveries/new-delivery-request",
                element: <NewDelivery />,
              },
              {
                path: "deliveries/auto-delivery-request/:id",
                element: <AutoDelivery />,
              },
              { path: "requests/:companyType", element: <Requests /> },
              {
                path: "report-monitoring",
                element: <ReportMonitoring />,
              },
              {
                path: "retailer/drf/user-management",
                element: <DRFUser />,
              },
              {
                path: "dg-health/financials",
                element: <DGHealthDashboard />,
              },
              {
                path: "admin/companies/transactions",
                element: <DRFTransactions />,
              },
              {
                path: "hospital-head/financials/drf",
                element: <HospitalHeadFinancial />,
              },
              {
                path: "hospital-head/report/drf",
                element: <HospitalHeadReport />,
              },
              {
                path: "pharmacy-head/stat",
                element: <PharmacyHeadStat />,
              },
              {
                path: "pharmacy-head/financials",
                element: <PharmacyHeadFinancialManagement />,
              },
              {
                path: "pharmacy-head/inventory",
                element: <PharmacyHeadInventory />,
              },
              {
                path: "pharmacy-head/inventory/all-drugs",
                element: <AllPharmacyDrugs />,
              },
              {
                path: "pharmacy-head/inventory/notifications",
                element: <PharmacyHeadNotifications />,
              },
              {
                path: "accountant/financials",
                element: <AccountantFinancials />,
              },
              {
                path: "accountant/financials/month-sale",
                element: <MonthSale />,
              },
              {
                path: "accountant/audit",
                element: <AccountantAudit />,
              },
              {
                path: "state-sec/dashboard/drf",
                element: <StateDashboard />,
              },
              {
                path: "state-sec/fund-allocation/drf/:rowId",
                element: <FundAllocationHistory />,
              },
              {
                path: "state-sec/financials/drf",
                element: <SecreataryFinancials />,
              },

              // ***** admin routes ********
              {
                path: "admin/companies/dashboard",
                element: <AdminDashboard />,
              },
              {
                path: "admin/companies/drf",
                element: <DRF />,
              },
              {
                path: "admin/cluster",
                element: <AdminCluster />,
              },
              {
                path: "admin/companies/wallet",
                element: <AdminWallet />,
              },
              {
                path: "state-sec/drf-facility/drf/:rowId",
                element: <DRFFacility />,
              },
              { path: "admin/companies/queried", element: <Companies /> },
              { path: "admin/companies/approved", element: <Companies /> },
              { path: "admin/companies/declined", element: <Companies /> },
              { path: "admin/companies/pending", element: <Companies /> },
              {
                path: "admin/companies/details/:id/:type",
                element: <ComapanyDetails />,
              },

              {
                element: (
                  <RequireAuth allowedRoles={["retailer", "distributor"]} />
                ),
                children: [
                  { path: "rfq", element: <Rfq /> },
                  { path: "rfq/retailer/view-rfq/:id", element: <ViewRFQ /> },
                  {
                    path: "rfq/distributor/view-rfq/:id",
                    element: <RespondRfq />,
                  },
                  { path: "rfq/make-rfq", element: <NewRFQ /> },
                  { path: "rfq/edit-rfq", element: <EditRfq /> },
                ],
              },
              { path: "admin/products/queried", element: <AdminProducts /> },
              { path: "admin/products/approved", element: <AdminProducts /> },
              { path: "admin/products/declined", element: <AdminProducts /> },
              { path: "admin/products/pending", element: <AdminProducts /> },
              {
                path: "admin/products/details/:type/:id",
                element: <AdminProductDetails />,
              },
              {
                path: "pcn-admin/invite-companies",
                element: <InviteCompanies />,
              },
              {
                path: "ministry-admin",
                element: <MinistryAdminStats />,
              },
              {
                path: "state-ministry",
                element: <StateMinistryStats />,
              },
              {
                path: "messages",
                element: <DashboardMessages />,
              },
              {
                path: "notifications",
                element: <NotificationCenter />,
              },
              { path: "*", element: <NotFound /> },
            ],
          },
        ],
      },
    ],
  },
]);
